module.exports = __webpack_public_path__ + "static/media/Colette Ray Single Headboard - 120 cm.0210b774.jpg";